import type { ButtonHTMLAttributes, ReactNode } from 'react';
import styles from './style.module.css';

type Variant = 'primary' | 'ghost' | 'link';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  loading?: boolean;
  loadingText?: string;
  children: ReactNode;
};

export function Button({ variant = 'primary', loading = false, loadingText, children, disabled, className, ...rest }: Props) {
  return (
    <button type="button" disabled={disabled || loading} className={`${styles.base} ${styles[variant]}${className ? ` ${className}` : ''}`} {...rest}>
      {loading ? (loadingText ?? children) : children}
    </button>
  );
}
